import React from "react";
import { Box, Typography, TextField, Chip } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Controller } from "react-hook-form";

const FormQualifications = ({
  label,
  name,
  control,
  errors,
  options = [],
  required = false,
  placeholder = "Select Qualifications",
}) => {
  return (
    <Box>
      {/* Label */}
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: "var(--app-text-muted)",
          mb: "6px",
          fontFamily: "figtree",
        }}
      >
        {label}
        {required && <span style={{ color: "#d32f2f" }}> *</span>}
      </Typography>

      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const selectedOptions = options.filter((opt) =>
            (field.value || []).includes(opt.value)
          );

          return (
            <Autocomplete
              multiple
              options={options}
              value={selectedOptions}

              // 🔥 IMPORTANT
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }

              getOptionLabel={(option) => option.label}

              onChange={(_, newValue) =>
                field.onChange(newValue.map((opt) => opt.value))
              }

              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={option.value}
                    label={option.label}
                    sx={{
                      backgroundColor: "#FFF3E3",
                      borderRadius: "10px",
                      height: "36px",
                      fontSize: "14px",
                      fontWeight: 500,
                      px: "6px",
                      color:"#1e1e1e",
                      "& .MuiChip-deleteIcon": {
                        color: "var(--app-text)",
                        backgroundColor: "var(--app-surface)",
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        ml: "6px",
                      },
                    }}
                  />
                ))
              }

              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="filled"
                  hiddenLabel
                  placeholder={
                    selectedOptions.length === 0 ? placeholder : ""
                  }
                  error={!!errors?.[name]}
                  helperText={errors?.[name]}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      minHeight: "52px",
                      backgroundColor: "var(--app-surface)",
                      borderRadius: "10px",
                      border: "1px solid var(--app-border)",
                      padding: "6px 10px",
                      fontFamily: "figtree",
                    },
                    "& .MuiFilledInput-root:hover": {
                      backgroundColor: "var(--app-surface)",
                    },
                    "& .MuiFilledInput-root.Mui-focused": {
                      backgroundColor: "var(--app-surface)",
                    },
                    "& .MuiFilledInput-root:before, & .MuiFilledInput-root:after": {
                      display: "none",
                    },
                  }}
                />
              )}
            />
          );
        }}
      />
    </Box>
  );
};

export default FormQualifications;
